import { render, staticRenderFns } from "./questionquery.vue?vue&type=template&id=218b284c&scoped=true&"
import script from "./questionquery.vue?vue&type=script&lang=js&"
export * from "./questionquery.vue?vue&type=script&lang=js&"
import style0 from "./questionquery.vue?vue&type=style&index=0&id=218b284c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b284c",
  null
  
)

component.options.__file = "questionquery.vue"
export default component.exports